import { useTranslation } from 'react-i18next';
import type { ClassificationWithLimitsWithExistingFlagDtoIn } from '@/models/in/ClassificationWithLimitsWithExistingFlagDtoIn';
import styles from './ClassificationsSection.module.css';

interface ClassificationsSectionProps {
  classificationsData: ClassificationWithLimitsWithExistingFlagDtoIn[];
  selectedIds: number[];
  onToggle: (classificationId: number) => void;
}

const ClassificationsSection = ({ classificationsData, selectedIds, onToggle }: ClassificationsSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4 className="text-body-lr-semibold">{t('supportGoalsTitle')}</h4>
        <p className="text-body-sm-regular">{t('fundSelectionSubtitle')}</p>
      </div>

      <div className={styles.grid}>
        {classificationsData.map((item) => {
          const classification = item.classificationWithLimits.classification;
          const isExisting = item.existsForSupported;
          const isSelected = selectedIds.includes(classification.id);

          const cardClass = isExisting
            ? `${styles.card} ${styles.existing}`
            : isSelected
              ? `${styles.card} ${styles.selected}`
              : `${styles.card} ${styles.default}`;

          return (
            <div key={classification.id} className={cardClass} onClick={() => !isExisting && onToggle(classification.id)}>
              {isExisting && <div className={styles.existingBadge}>{t('existingClassification')}</div>}

              <div className={styles.cardContent}>
                <div className={styles.nameWrapper}>
                  <h5 className={isExisting ? styles.nameDisabled : styles.name}>{t(classification.name)}</h5>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClassificationsSection;
